import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Button } from "react-bootstrap";

const DatabaseButton = ({
  onClick,
  enabled
}) => /*#__PURE__*/React.createElement(Button, {
  onClick: () => onClick(),
  variant: "outline-secondary",
  active: enabled,
  title: "Database table view"
}, /*#__PURE__*/React.createElement(FontAwesome, {
  name: "fas fa-server"
}));

export default DatabaseButton;